import NewCamera from './pages/NewCamera.svelte';
import Feedback from './pages/Feedback.svelte';
import End from './pages/End.svelte';
import Home from './pages/Home.svelte';
export default {
    '/': Home,
    // '/client/:room': NewCamera,
    // '/expert/:room': NewCamera,
    '/call/:room': NewCamera,
    '/feedback/:room': Feedback,
    '/end': End,
    '/:room': Home,
};
